"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToast = exports.ToastProvider = void 0;
const react_1 = __importStar(require("react"));
const icon_new_1 = __importDefault(require("../icon-new"));
const styled_components_1 = __importStar(require("styled-components"));
const { Accepted, Warning, Error } = icon_new_1.default;
const Wrapper = styled_components_1.default.div `
  position: fixed;
  bottom: 8px;
  display: flex;
  justify-content: center;
  width: 95%;
  margin: 0 auto;
  z-index: 999999999;
`;
const ToastText = styled_components_1.default.div `
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;
const fadeIn = (0, styled_components_1.keyframes) `
    from {
        opacity: 0;
        top: 30px;
    }
    to {
        opacity: 1;
        top: 0px;
    }
`;
const fadeOut = (0, styled_components_1.keyframes) `
    from {
        opacity: 1;
        top: 0px;
    }
    to {
        opacity: 0;
        top: 30px;
    }
`;
const ToastWrapper = styled_components_1.default.div `
  animation: ${({ isOut }) => (isOut ? fadeOut : fadeIn)} ease-in-out 300ms;
  width: auto;
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: auto 1fr;
  grid-gap: 8px;
  height: 40px;
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 8px;
  background-color: ${({ severity, theme }) => {
    const colorMapping = {
        success: theme.success.main,
        error: theme.error.main,
        warning: theme.warning.main
    };
    return colorMapping[severity] || colorMapping["success"];
}};
  color: ${({ severity, theme }) => {
    const colorMapping = {
        success: theme.white,
        error: theme.white,
        warning: theme.text.primary
    };
    return colorMapping[severity] || colorMapping["success"];
}};
`;
const getIcon = (severity) => {
    switch (severity) {
        case "error":
            return react_1.default.createElement(Error, null);
        case "warning":
            return react_1.default.createElement(Warning, null);
        default:
            return react_1.default.createElement(Accepted, null);
    }
};
const RotaToast = ({ children, severity = "success", duration }) => {
    const [fadeOut, setFadeOut] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => {
            setFadeOut(true);
        }, duration);
        return () => {
            setFadeOut(false);
            clearTimeout(timeout);
        };
    }, [setFadeOut]);
    return (react_1.default.createElement(ToastWrapper, { severity: severity, isOut: fadeOut },
        getIcon(severity),
        react_1.default.createElement(ToastText, null,
            " ",
            children)));
};
const initialContext = {
    showToast: () => { },
    hideToast: () => { }
};
const ToastContext = (0, react_1.createContext)(initialContext);
const defaultOptions = {
    duration: 3000
};
const delay = (ms) => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};
function ToastProvider({ children }) {
    const [toasts, setToasts] = (0, react_1.useState)([]);
    const showToast = (0, react_1.useCallback)((message, partialOptions = defaultOptions, id = new Date().getTime().toString()) => __awaiter(this, void 0, void 0, function* () {
        const options = Object.assign(Object.assign({}, defaultOptions), partialOptions);
        setToasts(toasts => [{ id, toast: { message, options } }, ...toasts]);
        yield delay(options.duration);
        setToasts(toasts => toasts.filter(toast => toast.id !== id));
    }), [setToasts]);
    const hideToast = (0, react_1.useCallback)((id) => {
        setToasts(toasts => toasts.filter(toast => toast.id !== id));
    }, [setToasts]);
    return (react_1.default.createElement(ToastContext.Provider, { value: { showToast, hideToast } },
        children,
        toasts.length > 0 && (react_1.default.createElement(Wrapper, null,
            react_1.default.createElement("div", null, toasts.map(({ id, toast }) => (react_1.default.createElement(RotaToast, Object.assign({ key: id }, toast.options, { onHide: () => hideToast(id) }), toast.message))))))));
}
exports.ToastProvider = ToastProvider;
function useToast() {
    return (0, react_1.useContext)(ToastContext);
}
exports.useToast = useToast;
